define( function() {
	"use strict";

	return Date.now();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/nonce.js
// module id = 265
// module chunks = 27